<template>
  <div>
    <DocumentCardIterator
      v-if="journal.recommendations.length > 0"
      :items="journal.recommendations"
      :pagination="true"
      :display-num-documents="false"
      @clicked="onRecommendationClicked"
    >
      <template v-slot:header>
        <JournalSectionHeader
          :journal="journal"
          :show-actions="showActions"
        />
      </template>
      <template v-slot:item="{ item }">
        <HorizontalCard
          large
          :key="item.id"
          :event-bus="RecommendationEventBus"
          @clicked="$emit('clicked', $event)"
          :allow-adding-to-reflection="true"
          :show-evaluation="true"
          :show-avatar="true"
          :document-data="item"
          target="_blank"
        />
      </template>
    </DocumentCardIterator>
    <div v-else>
      <JournalSectionHeader
        :journal="journal"
      />
      <div class="px-2 py-4">
        <span
          style="font-weight: 300;font-style: italic; opacity: 65%;"
        >
          {{ $t('views.journal.messages.loading') }}
        </span>
        <v-divider class="mt-2" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { types } from '../../store/rootTypes';
import DocumentCardIterator from '../cards/DocumentCardIterator';
import HorizontalCard from '../cards/documentCards/HorizontalCard';
import JournalSectionHeader from './JournalSectionHeader';
import { RecommendationEventBus } from '../cards/documentCards/RecommendationEventBus';

export default {
  name: 'JournalSection',
  components: {
    HorizontalCard,
    DocumentCardIterator,
    JournalSectionHeader,
  },
  props: {
    journal: {
      type: Object,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    RecommendationEventBus,
  }),
  methods: {
    ...mapActions({
      markUserJournalAsRead: types.authentication.actions.markUserJournalAsRead,
      recommendationClicked: types.recommendationBasedJournals.actions.recommendationClicked,
    }),
    onRecommendationClicked(documentData) {
      return Promise.all([
        this.markUserJournalAsRead(),
        this.recommendationClicked({ doc: documentData }),
      ]);
    },
  },
};
</script>
<style scoped>
</style>
